import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { Alert, Button, Stack, Typography } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import LoadingScreen from '@/components/LoadingScreen'
import type { IRootState } from '@/store/store'
import { loadEsriApiKey } from '@/utils/esriConfig'

export const RequireEsriConfig = () => {
    const token = useSelector((state: IRootState) => state.app.token)
    const [result, setResult] = useState<{ token: string; error?: string }>()
    const [attempt, setAttempt] = useState(0)

    useEffect(() => {
        if (!token) return
        let active = true
        setResult(undefined)
        void loadEsriApiKey(token).then(
            () => { if (active) setResult({ token }) },
            (error: unknown) => {
                if (active) setResult({
                    token,
                    error: error instanceof Error ? error.message : 'Unable to load map credentials.',
                })
            },
        )
        return () => { active = false }
    }, [token, attempt])

    if (!token || result?.token !== token) {
        return <LoadingScreen><Typography role="status">Loading map credentials</Typography></LoadingScreen>
    }

    if (result.error) {
        return <Stack spacing={2} alignItems="center" sx={{ p: 3 }}>
            <Alert severity="error">{result.error}</Alert>
            <Button startIcon={<RefreshIcon />} onClick={() => {
                setResult(undefined)
                setAttempt(value => value + 1)
            }}>Retry</Button>
        </Stack>
    }

    return <Outlet />
}